<template>  
  <v-card>
    <v-card-text>
      <v-container fluid grid-list-lg class="ma-0 pa-0">
        <v-layout row>
          <v-flex xs12 md12 style="position:relative">
            <v-btn fab color="green" dark small absolute right :to="{name:'admin/users/form'}"><v-icon>add</v-icon></v-btn>                      
            <v-text-field flat dense filled
              v-model="term"
              append-icon="search"
              label="Search User"
              single-line
              hide-details
              style="width:250px"
              @input="search"
            ></v-text-field>                
          </v-flex>
        </v-layout>
      </v-container>    
    </v-card-text>
    <v-card-text class="pa-0">      
      <v-container fluid grid-list-lg class="ma-0 pa-0">
        <v-layout row>
          <v-flex xs12 md12 style="position:relative">
            <v-data-table dense
              :headers="headers"
              :items="items"              
              :loading="loading"
              loading-text="Loading... Please wait"
              :items-per-page="-1"
              hide-default-footer            
              :options.sync="options"              
            >               
              <template v-slot:item.no="{ item }">{{ ((page-1)*20)+(items.findIndex(x=>x==item)+1) }}</template>
              <template v-slot:item.status="{ item }">
                <v-chip small :color="getStatusColor(item.status)" dark>{{status[item.status]}}</v-chip>
              </template>
              <template v-slot:item.roles="{ item }">
                <span v-for="(role, i) in item.roles" :key="i">{{role}}, </span>                
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn icon small color="blue" :to="{name:'admin/users/form',query:{id:item.id}}"><v-icon>edit</v-icon></v-btn>
              </template>              
            </v-data-table>
            <div class="text-center">
              <v-pagination
                v-model="page"
                :length="totalPages"
                circle
              ></v-pagination>
            </div>
          </v-flex>          
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card> 
</template>

<script>
import { debounce } from 'lodash'
import Model from '@/app/models/Admin'
const  model = new Model()

export default {
  data () {
    return {
      term : null,
      headers: [
        {text: 'No', value:'no'},
        {text: 'Username', value:'username'},
        {text: 'Fullname', value:'name'},
        {text: 'phone', value:'phone'},
        {text: 'Email', value:'email'},
        {text: 'Status', value:'status'},
        {text: 'Roles', value:'roles'},
        {text: 'Action', value:'action'},
      ],      
      items: [],    
      options:{sortBy:[]}, 
      page : 1,      
      totalPages: 0,      
      loading: false,           
    }
  }, 
  created () {
    this.readItems()
  },  
  computed:{
    status(){
      return this.$store.getters.DICTIONS.UserStatus;      
    }
  },
  watch : {
    page(newPage){
      this.readItems(newPage);
    },
    options:{
      handler(){
        this.readItems(this.page) 
      }, deep:true      
    }
  }, 
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    readItems (page = 0) {
      this.loading = true
      let  sortby = this.options.sortBy[0] ? this.options.sortDesc[0] ? 
        '-'+this.options.sortBy[0] : this.options.sortBy[0] : 'id'; 

      const params = {        
        page: page,
        q: this.term,
        sort:sortby,
        expand:'roles'
      }

      model.all(params)
        .then(response => {
          this.items = response.data;
          this.totalPages = response.pagination.pageCount;               
          this.loading = false
        })
    },

    getStatusColor (status) {
      if (status === 10) {
        return 'success'
      }

      if (status === 'processing') {
        return 'info'
      }

      return 'danger'
    },    
  },  
}
</script>
